/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_IntroInputs */

const bn_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিশ্বের হাইলাইট করা দেশটিকে আপনি যত দ্রুত এবং নির্ভুলভাবে শনাক্ত করুন।`)
};

const de_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifizieren Sie das markierte Land auf dem Globus so schnell und genau wie möglich.`)
};

const el_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προσδιορίστε την επισημασμένη χώρα στον κόσμο όσο πιο γρήγορα και με ακρίβεια μπορείτε.`)
};

const en_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identify the highlighted country on the globe as quickly and accurately as you can.`)
};

const es_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifique el país resaltado en el mundo de la manera más rápida y precisa que pueda.`)
};

const fr_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiez le pays surligné sur le globe aussi vite et précisément que possible.`)
};

const hi_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जितनी जल्दी और सटीक रूप से आप कर सकते हैं, ग्लोब पर हाइलाइट किए गए देश की पहचान करें।`)
};

const hu_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lehető leggyorsabban és legpontosabban azonosítsa a kiemelt országot a földgömbön.`)
};

const id_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifikasi negara yang disorot di dunia secepat dan seakurat mungkin.`)
};

const it_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifica il paese evidenziato sul globo nel modo più rapido e preciso possibile.`)
};

const ja_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地球上でハイライト表示されている国をできるだけ早く正確に特定します。`)
};

const ko_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가능한 한 빠르고 정확하게 지구상에서 강조 표시된 국가를 식별하십시오.`)
};

const nl_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificeer het gemarkeerde land op de wereld zo snel en nauwkeurig mogelijk.`)
};

const pl_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zidentyfikuj podświetlony kraj na świecie tak szybko i dokładnie, jak to tylko możliwe.`)
};

const pt_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifique o país destacado no globo com a maior rapidez e precisão possível.`)
};

const ru_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Определите выделенную страну на земном шаре как можно быстрее и точнее.`)
};

const sv_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiera det markerade landet på jordklotet så snabbt och exakt du kan.`)
};

const tr_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünya üzerinde vurgulanan ülkeyi olabildiğince hızlı ve doğru bir şekilde tanımlayın.`)
};

const uk_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Визначте виділену країну на глобусі якнайшвидше й точніше.`)
};

const vi_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác định quốc gia được đánh dấu trên toàn cầu một cách nhanh chóng và chính xác nhất có thể.`)
};

const zh_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尽可能快速准确地识别地球上突出显示的国家/地区。`)
};

const zh_hant_how_to_play_intro = /** @type {(inputs: How_To_Play_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`盡可能快速且準確地識別地球上突出顯示的國家/地區。`)
};

/**
* | output |
* | --- |
* | "Identify the highlighted country on the globe as quickly and accurately as you can." |
*
* @param {How_To_Play_IntroInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_intro = /** @type {((inputs?: How_To_Play_IntroInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_IntroInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_intro(inputs)
	if (locale === "de") return de_how_to_play_intro(inputs)
	if (locale === "el") return el_how_to_play_intro(inputs)
	if (locale === "en") return en_how_to_play_intro(inputs)
	if (locale === "es") return es_how_to_play_intro(inputs)
	if (locale === "fr") return fr_how_to_play_intro(inputs)
	if (locale === "hi") return hi_how_to_play_intro(inputs)
	if (locale === "hu") return hu_how_to_play_intro(inputs)
	if (locale === "id") return id_how_to_play_intro(inputs)
	if (locale === "it") return it_how_to_play_intro(inputs)
	if (locale === "ja") return ja_how_to_play_intro(inputs)
	if (locale === "ko") return ko_how_to_play_intro(inputs)
	if (locale === "nl") return nl_how_to_play_intro(inputs)
	if (locale === "pl") return pl_how_to_play_intro(inputs)
	if (locale === "pt") return pt_how_to_play_intro(inputs)
	if (locale === "ru") return ru_how_to_play_intro(inputs)
	if (locale === "sv") return sv_how_to_play_intro(inputs)
	if (locale === "tr") return tr_how_to_play_intro(inputs)
	if (locale === "uk") return uk_how_to_play_intro(inputs)
	if (locale === "vi") return vi_how_to_play_intro(inputs)
	if (locale === "zh") return zh_how_to_play_intro(inputs)
	return zh_hant_how_to_play_intro(inputs)
});